
export const OtherTransactionsStyles = theme => ({
    root: {
        backgroundColor: 'white',
        border: '1px solid #6D6E6E',
        marginTop: '-10px'
    },
    cardHeader: {
        backgroundColor: '#7AA4D5',
        color: "white",
        textAlign: 'center',
        padding: '5px'
    },
    cardHeaderDisabled: {
        backgroundColor: '#b4bfcd',
        color: "white"
    },
    subHeaderPadding: {
        padding: 'px',
    },
    subHeaderGrey: {
        backgroundColor: '#F1F1F1'
    },
    dashboardAlign: {
        textAlign: 'center'
    },
    dashboardIcon: {
        fontSize: '40px',
        color: '#79ba00'
    },
    dashboardIconDisabled: {
        fontSize: '40px',
        color: '#9eb17b'
    },
    searchAlign: {
        textAlign: 'right'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    },
    marginNoData: {
        margin: '25px'
    },
    titles: {
        color: "black",
        fontSize: "22px",
        marginBottom: '10px',
        marginTop: '10px'
    },
    borderRadius: {
        borderRadius: '0px'
    },
    generalBorder: {
        border: '1px solid #7A9BC2',
    },
    paddingTabPanel: {
        paddingLeft: '0px',
        paddingTop: '0px',
        paddingRight: '0px'
    },
    buttonAlign: {
        textAlign: 'right'
    },
    borderLeft: {
        borderLeft: '1px solid #7A9BC2'
    },
    text:{
        color: 'black',
        padding: '5px 10px'
    },
    textDisaled:{
        color: '#afb1b3'
    },
    textTitle:{
        color: 'black',
        fontWeight: 'bold',
        padding: '5px 10px'
    },
    tableTitleAP: {
        marginTop: '0.5em',
        marginBottom: '0',
        marginLeft: '0.5em',
        fontSize: '22px',
        color: 'black'
    },
    generalBorderWithOutUpperCase: {
        border: '1px solid #7A9BC2',
        textTransform: 'none'
    },
    Requerid: {
        position: "absolute",
        marginLeft: "2px",
        color: "red",
        fontWeight: "bold",
        pointerEvents: "none"
    },
    RequeridSinAbsolue: {
        marginLeft: "2px",
        color: "red",
        fontWeight: "bold",
        pointerEvents: "none"
    }
})
